import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../../config";
import "./PotentialLostCustomers.css";

// "Potential Lost Customers" widget — a big circular button.
//
// It reads the existing lost-customer alerts (TR_LostCustomerAlert via
// /User/api/LostCustomerParameter/GetAlerts). When there are active alerts the
// user hasn't reviewed (IsAcknowledged === false), the button turns red and
// pulses with a flame so the team notices. Opening the view acknowledges them,
// so it returns to plain green until the nightly check re-flags still-lost
// customers.
//
// dataScope === "self" scopes the alerts to the logged-in salesperson
// (TR_ContactInfo.SalesPersonId), used by the Sales role.
const PotentialLostCustomers = ({ auth: { auth }, dataScope = "all", userId }) => {
  const [unreviewedCount, setUnreviewedCount] = useState(0);
  const navigate = useNavigate();

  const token = auth && auth[0] ? auth[0].token : null;
  let tmpSalesId = userId;
  if(auth && (auth[0]?.roleName ==='Sales' && auth[0]?.salesPersonId !=='')){
    tmpSalesId = auth[0]?.salesPersonId
  }
  const scopedSalesPersonId = dataScope === "self" ? tmpSalesId : null;

  useEffect(() => {
    if (!token) return;
    const params = { userId };
    if (scopedSalesPersonId) params.salesPersonId = scopedSalesPersonId;
    axios
      .get(`${API_URL}/User/api/LostCustomerParameter/GetAlerts`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => {
        const rows = Array.isArray(res.data)
          ? res.data
          : (res.data && res.data.result) || [];
        const unreviewed = rows.filter((r) => !r.isAcknowledged).length;
        setUnreviewedCount(unreviewed);
      })
      .catch((err) => {
        console.warn("Could not load Potential Lost Customers:", err.message);
      });
  }, [token, scopedSalesPersonId]);

  const hasAlerts = unreviewedCount > 0;

  return (
    <div className="plc-widget">
      <button
        type="button"
        className={`plc-button ${hasAlerts ? "plc-alert" : "plc-calm"}`}
        onClick={() => navigate("/potential-lost-customers")}
        title="View potential lost customers"
      >
        {hasAlerts && <span className="plc-flame" role="img" aria-label="alert">🔥</span>}
        <span className="plc-label">Potential Lost Customers</span>
        {hasAlerts && <span className="plc-count">{unreviewedCount}</span>}
      </button>
    </div>
  );
};

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(PotentialLostCustomers);
